import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import { getOpenedTaskDueDate, getOpenedTaskProjects, getOpenedTaskRecurringConfig } from '../../../../../redux/tasks/taskEntities/selectors';
import CalendarDropdown from '../../task-components/CalendarDropdown';

const TaskDetailsDueDate = ({ isModal, taskDueDate, taskId, taskProjects, taskRecurringConfig }) => {
  const taskObj = useMemo(() => ({
    _id: taskId,
    dueDate: taskDueDate,
    projects: taskProjects,
    recurringConfig: taskRecurringConfig
  }), [taskDueDate, taskId, taskProjects, taskRecurringConfig])

  return (
    <div className="flex items-center py-2.5 pr-2">
      <div className="w-32 shrink-0 flex items-center gap-2">
        <img src="/images/icons/calendar-gray.svg" alt="" className="w-4 h-4 shrink-0 opacity-50" />
        <span className="text-[13px] text-[rgba(15,15,25,0.5)] font-medium">
          <FormattedMessage id="DUE_DATE" defaultMessage="Due Date" />
        </span>
      </div>
      <div className="flex-1 flex justify-end">
        <CalendarDropdown task={taskObj} y={isModal ? -10 : -60} x={isModal && 800} isLarge showIcon={true} />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  taskDueDate: getOpenedTaskDueDate(state),
  taskId: getOpenedTaskId(state),
  taskProjects: getOpenedTaskProjects(state),
  taskRecurringConfig: getOpenedTaskRecurringConfig(state),
});

export default connect(mapStateToProps)(TaskDetailsDueDate);
